/* BASIQ · Carrito lateral — render, cantidades, escalado de descuento */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var root = null;
  var state = { cart: null, busy: false, lastFocus: null, locked: false };
  var tiers = [];
  var moneyFormat = '{{amount_with_comma_separator}} €';
  var T = {};

  /* cart.js no devuelve compare_at_price, así que lo traemos del producto y lo guardamos aquí */
  var COMPARE = {};
  var ASKED = {};
  /* Producto completo por handle (para poder cambiar de variante desde el carrito) */
  var PRODUCTS = {};

  /* ---------- utilidades ---------- */

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }

  function money(cents) {
    var value = (Math.round(cents) / 100).toFixed(2);
    if (moneyFormat.indexOf('comma_separator') !== -1 || moneyFormat.indexOf('€') !== -1) {
      value = value.replace('.', ',');
    }
    var out = moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, value)
      .replace(/\{\{\s*amount\s*\}\}/g, value);
    return out === moneyFormat ? value + ' €' : out;
  }

  function thumb(url) {
    if (!url) return '';
    return url.replace(/(\.(?:png|jpe?g|webp|gif))(\?.*)?$/i, '_200x$1$2');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Bloqueo de scroll que funciona en iPhone (definido en basiq-header.js) */
  function lockScroll(on) {
    if (on === state.locked) return;
    state.locked = on;
    if (window.BasiqScrollLock) {
      if (on) window.BasiqScrollLock.lock(); else window.BasiqScrollLock.unlock();
    } else {
      document.documentElement.style.overflow = on ? 'hidden' : '';
      document.body.style.overflow = on ? 'hidden' : '';
    }
  }

  /* ---------- precios de comparación ---------- */

  function loadCompare(cart) {
    var handles = [];
    for (var i = 0; i < cart.items.length; i++) {
      var h = cart.items[i].handle;
      if (h && !ASKED[h] && handles.indexOf(h) === -1) handles.push(h);
    }
    if (!handles.length) return Promise.resolve();

    return Promise.all(handles.map(function (handle) {
      ASKED[handle] = true;
      return fetch(ROOT + 'products/' + handle + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product || !product.variants) return;
          PRODUCTS[handle] = product;
          product.variants.forEach(function (v) {
            if (v.compare_at_price) COMPARE[v.id] = v.compare_at_price;
          });
        })
        .catch(function () {});
    }));
  }

  /* Tachado = precio de comparación del producto; si no hay, el precio de catalogo */
  function compareUnit(item) {
    var compare = COMPARE[item.variant_id] || item.compare_at_price || 0;
    var original = item.original_price || item.price || 0;
    return compare > original ? compare : original;
  }

  /* ---------- cambio de variante ---------- */

  function optionNames(product) {
    return (product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  }

  function optionValues(product, i) {
    var o = (product.options || [])[i];
    if (o && o.values && o.values.length) return o.values;
    var seen = [];
    product.variants.forEach(function (v) {
      var val = v.options ? v.options[i] : v['option' + (i + 1)];
      if (val != null && seen.indexOf(val) === -1) seen.push(val);
    });
    return seen;
  }

  function variantOptions(v) {
    /* Copia: así nunca se modifican los datos del producto */
    return (v.options || [v.option1, v.option2, v.option3]).filter(function (x) { return x != null; }).slice();
  }

  function findVariant(product, opts) {
    for (var i = 0; i < product.variants.length; i++) {
      var vo = variantOptions(product.variants[i]);
      var ok = true;
      for (var j = 0; j < opts.length; j++) if (vo[j] !== opts[j]) { ok = false; break; }
      if (ok) return product.variants[i];
    }
    return null;
  }

  /* Pastillas para elegir variante (solo si el producto tiene más de una) */
  function variantPicker(item) {
    var product = PRODUCTS[item.handle];
    if (!product || !product.variants || product.variants.length < 2) return '';
    var current = variantOptions(product.variants.filter(function (v) { return v.id === item.variant_id; })[0] || {});
    if (!current.length) return '';
    var names = optionNames(product);

    return names.map(function (name, i) {
      if (name === 'Title') return '';
      var pills = optionValues(product, i).map(function (val) {
        var test = current.slice();
        test[i] = val;
        var v = findVariant(product, test);
        var on = val === current[i];
        var off = !v || v.available === false;
        return '<button type="button" class="bc__vp-pill' + (on ? ' is-on' : '') + '"' +
          ' data-bc-vp data-index="' + i + '" data-value="' + esc(val) + '"' +
          (on ? ' aria-pressed="true"' : ' aria-pressed="false"') +
          (off && !on ? ' disabled' : '') + '>' + esc(val) + '</button>';
      }).join('');
      return '<div class="bc__vp" role="group" aria-label="' + esc(name) + '">' +
        '<span class="bc__vp-name">' + esc(name) + '</span>' + pills + '</div>';
    }).join('');
  }

  /* Enlaces "+ Añadir también en <color>": colores que aún no están en el carrito */
  function alsoLinks(item) {
    var product = PRODUCTS[item.handle];
    if (!product || !product.variants || product.variants.length < 2 || !state.cart) return '';
    var current = variantOptions(product.variants.filter(function (v) { return v.id === item.variant_id; })[0] || {});
    if (!current.length) return '';

    /* Opción de color: la que se llame color/colour; si no, la primera con varios valores */
    var names = optionNames(product);
    var ci = -1;
    names.forEach(function (n, i) { if (ci === -1 && /^(color|colour|colore|couleur|farbe)$/i.test(String(n).trim())) ci = i; });
    if (ci === -1) {
      for (var i = 0; i < names.length; i++) if (optionValues(product, i).length > 1) { ci = i; break; }
    }
    if (ci === -1) return '';

    var inCart = {};
    state.cart.items.forEach(function (it) { inCart[it.variant_id] = true; });

    return optionValues(product, ci).map(function (val) {
      if (val === current[ci]) return '';
      var test = current.slice();
      test[ci] = val;
      var v = findVariant(product, test);
      if (!v || v.available === false || inCart[v.id]) return '';
      return '<button type="button" class="bc__also" data-bc-also data-id="' + v.id + '">' +
        esc(T.also.replace('{v}', String(val).toLowerCase())) + '</button>';
    }).join('');
  }

  function addVariant(id) {
    if (state.busy) return;
    state.busy = true;
    loading(true);

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('bp:cart-updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'basiq-cart', data: { source: 'basiq-cart', itemCount: cart.item_count } }
        }));
      })
      .catch(function () { return fetchCart(); })
      .then(function () {
        state.busy = false;
        loading(false);
      });
  }

  function swapVariant(item, newId) {
    if (state.busy) return;
    state.busy = true;
    loading(true);

    var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var add = { id: newId, quantity: item.quantity };
    if (item.properties && Object.keys(item.properties).length) add.properties = item.properties;

    /* Las claves de línea cambian cuando cambia el descuento por cantidad,
       así que primero se busca la línea actual, se quita y después se suma la nueva variante. */
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = cart.items || [];
        var idx = -1;
        for (var i = 0; i < lines.length; i++) if (lines[i].key === item.key) { idx = i; break; }
        if (idx === -1) for (var j = 0; j < lines.length; j++) if (lines[j].variant_id === item.variant_id) { idx = j; break; }
        if (idx === -1) throw new Error('line');
        add.quantity = lines[idx].quantity;
        return fetch(ROOT + 'cart/change.js', {
          method: 'POST', headers: H, credentials: 'same-origin',
          body: JSON.stringify({ line: idx + 1, quantity: 0 })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('remove'); return r.json(); })
      .then(function () {
        return fetch(ROOT + 'cart/add.js', {
          method: 'POST', headers: H, credentials: 'same-origin',
          body: JSON.stringify({ items: [add] })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(apply)
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('bp:cart-updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'basiq-cart', data: { source: 'basiq-cart', itemCount: cart.item_count } }
        }));
      })
      .catch(function () { return fetchCart(); })
      .then(function () {
        state.busy = false;
        loading(false);
      });
  }

  /* ---------- escalado por cantidad ---------- */

  function parseTiers(raw) {
    return String(raw || '')
      .split(',')
      .map(function (part) {
        var bits = part.split(':');
        return { qty: parseInt(bits[0], 10), pct: parseFloat(bits[1]) };
      })
      .filter(function (t) { return t.qty > 0 && t.pct > 0; })
      .sort(function (a, b) { return a.qty - b.qty; });
  }

  function tierIndex(units) {
    var idx = -1;
    for (var i = 0; i < tiers.length; i++) if (units >= tiers[i].qty) idx = i;
    return idx;
  }

  function currentTier(units) {
    var i = tierIndex(units);
    return i === -1 ? null : tiers[i];
  }

  function nextTier(units) {
    for (var i = 0; i < tiers.length; i++) if (units < tiers[i].qty) return tiers[i];
    return null;
  }

  /* Cada nivel ocupa un tramo igual de la barra.
     Antes del primer nivel: un poco avanzada, sin llegar a la marca.
     Al alcanzar un nivel: pasa un poco su marca. Último nivel: llena. */
  function barWidth(units) {
    var n = tiers.length;
    if (!n || units < 1) return 0;
    var seg = 100 / n;
    var idx = tierIndex(units);
    if (idx === -1) return seg * 0.7 * Math.min(units / tiers[0].qty, 1);
    if (idx === n - 1) return 100;
    return (idx + 1) * seg + 5;
  }

  function renderLadder(units) {
    var box = $('[data-bc-ladder]');
    var msg = $('[data-bc-ladder-msg]');
    var bar = $('[data-bc-bar]');
    var marks = $('[data-bc-marks]');
    var steps = $('[data-bc-steps]');
    if (!box || !tiers.length) return;

    if (units < 1) { box.hidden = true; return; }
    box.hidden = false;

    var n = tiers.length;
    var next = nextTier(units);
    var top = tiers[n - 1];

    if (next) {
      var missing = next.qty - units;
      msg.innerHTML = (missing === 1 ? T.addOne : T.addMore.replace('{n}', missing)) +
        ' <strong>' + next.pct + '%</strong>';
      msg.classList.remove('is-max');
    } else {
      msg.innerHTML = T.max + ' <strong>' + top.pct + '%</strong>';
      msg.classList.add('is-max');
    }

    bar.style.width = barWidth(units) + '%';

    marks.innerHTML = tiers.map(function (t, i) {
      var on = units >= t.qty ? ' is-on' : '';
      return '<span class="bc__mark' + on + '" style="left:' + (((i + 1) / n) * 100) + '%"></span>';
    }).join('');

    steps.style.gridTemplateColumns = 'repeat(' + n + ', 1fr)';
    steps.innerHTML = tiers.map(function (t) {
      var on = units >= t.qty ? ' class="is-on"' : '';
      return '<li' + on + '>' + t.qty + '+ · ' + t.pct + '%</li>';
    }).join('');
  }

  /* ---------- totales ---------- */

  function totals(cart) {
    var compare = 0;
    for (var i = 0; i < cart.items.length; i++) {
      compare += compareUnit(cart.items[i]) * cart.items[i].quantity;
    }

    var tier = currentTier(cart.item_count);
    var applied = (cart.total_discount || 0) > 0;
    var base = cart.total_price;

    /* Si Shopify aún no ha aplicado el descuento automático, lo calculamos
       para que el total coincida con lo que se pagará en el checkout. */
    var final = (tier && !applied) ? Math.round(base * (1 - tier.pct / 100)) : base;

    return {
      compare: compare,
      final: final,
      saved: Math.max(0, compare - final),
      pct: compare > 0 ? Math.round(((compare - final) / compare) * 100) : 0
    };
  }

  /* ---------- render ---------- */

  function render() {
    var cart = state.cart;
    if (!cart) return;

    var items = $('[data-bc-items]');
    var empty = $('[data-bc-empty]');
    var foot = $('[data-bc-foot]');

    $('[data-bc-count]').textContent = cart.item_count;

    if (!cart.items.length) {
      items.innerHTML = '';
      empty.hidden = false;
      foot.hidden = true;
      $('[data-bc-ladder]').hidden = true;
      syncHeader(0);
      return;
    }

    empty.hidden = true;
    foot.hidden = false;

    items.innerHTML = cart.items.map(function (item, i) {
      var opts = item.options_with_values || [];
      var variant = opts
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return esc(o.value); })
        .join(' · ');

      var picker = variantPicker(item);
      var also = alsoLinks(item);

      var compareLine = compareUnit(item) * item.quantity;
      var was = compareLine > item.final_line_price
        ? '<span class="bc__was">' + money(compareLine) + '</span>'
        : '';

      return '' +
        '<li class="bc__item" data-bc-item data-line="' + (i + 1) + '" data-key="' + esc(item.key) + '">' +
          '<div class="bc__thumb">' +
            (item.image ? '<img src="' + esc(thumb(item.image)) + '" alt="' + esc(item.product_title) + '" loading="lazy" width="76" height="76">' : '') +
          '</div>' +
          '<div class="bc__info">' +
            '<p class="bc__name"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></p>' +
            (picker || (variant ? '<p class="bc__variant">' + variant + '</p>' : '')) +
            also +
            '<div class="bc__line">' +
              '<div class="bc__qty">' +
                '<button type="button" data-bc-minus aria-label="' + esc(T.less) + '">−</button>' +
                '<span data-bc-qty>' + item.quantity + '</span>' +
                '<button type="button" data-bc-plus aria-label="' + esc(T.more) + '">+</button>' +
              '</div>' +
              '<div class="bc__prices">' + was +
                '<span class="bc__price">' + money(item.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="bc__remove" data-bc-remove>' + esc(T.remove) + '</button>' +
          '</div>' +
        '</li>';
    }).join('');

    renderLadder(cart.item_count);

    var t = totals(cart);
    var saveRow = $('[data-bc-save-row]');
    var compareEl = $('[data-bc-compare]');

    if (t.saved > 0) {
      saveRow.hidden = false;
      $('[data-bc-save-value]').textContent = '− ' + money(t.saved);
      $('[data-bc-save-badge]').textContent = t.pct ? '-' + t.pct + '%' : '';
      $('[data-bc-save-badge]').hidden = !t.pct;
    } else {
      saveRow.hidden = true;
    }

    if (t.compare > t.final) {
      compareEl.hidden = false;
      compareEl.textContent = money(t.compare);
    } else {
      compareEl.hidden = true;
    }

    $('[data-bc-subtotal]').textContent = money(t.final);
    syncHeader(cart.item_count);
  }

  /* Contadores del header, sean cuales sean sus clases */
  function syncHeader(n) {
    var nodes = document.querySelectorAll(
      '[data-cart-count], .cart-count, .header__cart-count, .basiq-header__count, [data-bc-header-count]'
    );
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = n;
      nodes[i].hidden = n === 0;
      nodes[i].classList.toggle('is-empty', n === 0);
    }
  }

  /* ---------- datos ---------- */

  function loading(on) {
    var el = $('[data-bc-loading]');
    if (el) el.hidden = !on;
  }

  function apply(cart) {
    state.cart = cart;
    render();
    /* Cuando lleguen los precios de comparación, repintamos con el ahorro real */
    return loadCompare(cart).then(function () { render(); return cart; });
  }

  function fetchCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(apply);
  }

  function change(line, quantity) {
    if (state.busy) return;
    state.busy = true;
    loading(true);

    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(apply)
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('bp:cart-updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'basiq-cart', data: { source: 'basiq-cart', itemCount: cart.item_count } }
        }));
      })
      .catch(function () { return fetchCart(); })
      .then(function () {
        state.busy = false;
        loading(false);
      });
  }

  /* ---------- abrir / cerrar ---------- */

  function open() {
    if (!root) return;
    state.lastFocus = document.activeElement;
    root.hidden = false;
    /* Forzamos un repintado para que la transición de entrada se vea siempre (sobre todo en iPhone) */
    void root.offsetWidth;
    root.classList.add('is-open', 'is-opening');
    window.clearTimeout(state.openTimer);
    state.openTimer = window.setTimeout(function () { root.classList.remove('is-opening'); }, 1200);
    lockScroll(true);
    fetchCart();
    var closeBtn = $('[data-bc-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function close() {
    if (!root) return;
    window.clearTimeout(state.openTimer);
    root.classList.remove('is-open', 'is-opening');
    lockScroll(false);
    window.setTimeout(function () { root.hidden = true; }, 340);
    if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus({ preventScroll: true });
  }

  /* ---------- arranque ---------- */

  function init() {
    root = document.querySelector('[data-basiq-cart]');
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    tiers = parseTiers(root.getAttribute('data-tiers'));
    moneyFormat = root.getAttribute('data-money-format') || moneyFormat;
    T = {
      max: root.getAttribute('data-t-max') || '',
      addOne: root.getAttribute('data-t-add-one') || '',
      addMore: root.getAttribute('data-t-add-more') || '',
      remove: root.getAttribute('data-t-remove') || '',
      less: root.getAttribute('data-t-less') || '',
      more: root.getAttribute('data-t-more') || '',
      also: root.getAttribute('data-t-also') || '+ Añadir también en {v}'
    };

    $('[data-bc-overlay]').addEventListener('click', close);
    $('[data-bc-close]').addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    /* Cantidades y eliminar */
    root.addEventListener('click', function (e) {
      var item = e.target.closest ? e.target.closest('[data-bc-item]') : null;
      if (!item) return;

      var line = parseInt(item.getAttribute('data-line'), 10);

      var pill = e.target.closest('[data-bc-vp]');
      if (pill) {
        if (pill.disabled || pill.classList.contains('is-on')) return;
        var ci = state.cart && state.cart.items[line - 1];
        var product = ci && PRODUCTS[ci.handle];
        if (!product) return;
        var cur = variantOptions(product.variants.filter(function (v) { return v.id === ci.variant_id; })[0] || {});
        cur[parseInt(pill.getAttribute('data-index'), 10)] = pill.getAttribute('data-value');
        var target = findVariant(product, cur);
        if (target && target.id !== ci.variant_id) {
          item.classList.add('is-busy');
          swapVariant(ci, target.id);
        }
        return;
      }

      var alsoBtn = e.target.closest('[data-bc-also]');
      if (alsoBtn) {
        var newId = parseInt(alsoBtn.getAttribute('data-id'), 10);
        if (newId) { alsoBtn.disabled = true; addVariant(newId); }
        return;
      }

      var qty = parseInt(item.querySelector('[data-bc-qty]').textContent, 10) || 1;

      if (e.target.closest('[data-bc-plus]')) { item.classList.add('is-busy'); change(line, qty + 1); }
      else if (e.target.closest('[data-bc-minus]')) { item.classList.add('is-busy'); change(line, Math.max(0, qty - 1)); }
      else if (e.target.closest('[data-bc-remove]')) { item.classList.add('is-busy'); change(line, 0); }
    });

    /* Cualquier enlace o botón al carrito abre el cajón */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest
        ? e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-bc-open], [data-cart-drawer-trigger]')
        : null;
      if (!trigger) return;
      if (trigger.closest('[data-basiq-cart]')) return;
      e.preventDefault();
      open();
    });

    /* El botón de compra avisa por aquí */
    document.addEventListener('bp:cart-updated', function (e) {
      if (e.detail && e.detail.cart) {
        state.cart = e.detail.cart;
        render();
        loadCompare(e.detail.cart).then(render);
      }
    });
    document.addEventListener('basiq:cart:open', open);

    /* Contador correcto en la primera carga */
    fetchCart();
  }

  window.BasiqCart = { open: open, close: close, refresh: fetchCart };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
